window.bssB2BHooks = window.bssB2BHooks || {
  actions: {},
  filters: {},
};

window.BSS_B2B = window.BSS_B2B || {};

window.BSS_B2B.addAction = (tag, callback) => {
  window.bssB2BHooks.actions[tag] = callback;
};
window.BSS_B2B.addFilter = (tag, value) => {
  window.bssB2BHooks.filters[tag] = value;
};

function handle_response_products(curVariantId, { productFormId }) {
  if(window.location.pathname.includes("products")) {
    const urlObject = new URL(window.location.href);
    const variantId = urlObject.searchParams.get("variant");
  
    return Number(variantId);
  }
  
  return curVariantId;
  
}

window.BSS_B2B.addFilter('detect:product_variant', handle_response_products);

function customPrice(priceHTMLCustom, props) {
  const bssHiden = document.querySelectorAll("[bss-hiden]");
  if (bssHiden.length) {
    bssHiden.forEach(element => {
      element.style.display = "none";
    });
  }

  return priceHTMLCustom;
}

window.BSS_B2B.addFilter('custom:product_page/cp_pl_show_price', customPrice);

document.addEventListener('DOMContentLoaded', function () {
  document.body.addEventListener('click', function (e) {
    const quickViewBtn = e.target.closest('[bss-b2b-btn-quickview]');
    if (quickViewBtn) {
      setTimeout(() => {
        document.dispatchEvent(new Event('bss_b2b:QuickviewLoaded'));
        window.dispatchEvent(new Event("scroll"));
      }, 1000);
    }
  });

  if (typeof BSS_B2B !== "undefined" && BSS_B2B) {
    setTimeout(() => {
      const observer = new MutationObserver((MutationList) => {
        for (let item of MutationList) {
          if (item.target.classList?.contains('halo-cart-content')) {
            BSS_B2B.observer.cartSubject.listenCartCheckout();
          }
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }, 300);
  }
});

